module.exports = __webpack_public_path__ + "static/bg-05b6b9645d35812d972450a9ca66afb3.jpg";